import { apiClient } from "./apiClient";

export interface Country {
  label: string;
  value: string;
  code: string;
}

export const referenceDataService = {
  getCountries(): Promise<Country[]> {
    return apiClient.get<Country[]>("/reference-data/countries").then((r) => r.data);
  },
};
